export enum TABLE_BOOKINGS {}

export enum DATE_SELECTION_ENUM {
  TODAY = 'today',
  TOMORROW = 'tomorrow',
  CUSTOM = 'custom',
}

export enum TABLE_BOOKINGS_STATUS_ENUM {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  MODIFICATION_REQUESTED = 'MODIFICATION_REQUESTED',
}

export enum INTENT_ENUM {
  ACCEPT = 'ACCEPT',
  REJECT = 'REJECT',
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  ACCEPT_MODIFICATION = 'ACCEPT_MODIFICATION',
  REJECT_MODIFICATION = 'REJECT_MODIFICATION',
  CHECK_IN = 'CHECK_IN'
}

export enum TABLE_BOOKINGS_SOURCE {
  POS= 'posAppEE'
}

